"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SITE_DOWNLOAD: "@@print-bridge/site-download",
  PALETTE_LIST: "@@print-bridge/palette-list",
  SITE_PREVIEW: "@@print-bridge/site-preview",
  REPORT_DOWNLOAD: "@@print-bridge/report-download",
  REPORT_PREVIEW: "@@print-bridge/report-preview",
  CONTENT_PANEL_DOWNLOAD: "@@print-bridge/content-panel-download",
  CONTENT_PANEL_PREVIEW: "@@print-bridge/content-panel-preview",
  RESET: "@@print-bridge/reset",
  SUCCESS: "@@print-bridge/success",
  ERROR: "@@print-bridge/error"
};
exports.actionTypes = actionTypes;